const DIRECT_INFO_STATUS = {
    WAITING_FOR_CONTRACT: 'waiting_for_contract',
    WAITING_FOR_CUSTOMER: 'waiting_for_customer',
    WAITING_FOR_CONFIRM: 'waiting_for_contract_acceptance',
    ACCEPTED: 'customer_accepted_contract',
};

export { DIRECT_INFO_STATUS };